import { render, staticRenderFns } from "./member-coupon.vue?vue&type=template&id=b70d0af0&scoped=true&"
import script from "./member-coupon.vue?vue&type=script&lang=js&"
export * from "./member-coupon.vue?vue&type=script&lang=js&"
import style0 from "./member-coupon.vue?vue&type=style&index=0&id=b70d0af0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d0af0",
  null
  
)

export default component.exports